import { lazy } from "react"
import { Navigate } from "react-router-dom"
import Login from "../pages/Login"
import Index from '../pages/Index'
import Business from "../pages/Business"
import Sign from '../pages/Sign'
import Exam from '../pages/Exam'
import Team from '../pages/Team'
import Outside from '../pages/Outside'
import Activity from "../pages/Activity"
import Interface from "../pages/Interface"
import Calculator from "../pages/Calculator"
import FAQ from "../pages/FAQ"
import HouseLoan from "../pages/HouseLoan"
import Chattergee from "../pages/Chattergee"
import Letusign from "../pages/Letusign"

const BusinessAdd = lazy(()=>import('../pages/Business/Add'))
const BusinessList = lazy(()=>import('../pages/Business/List'))
const BusinessDetail = lazy(()=>import('../pages/Business/Detail'))
const BusinessReject = lazy(()=>import('../pages/Business/Reject'))
const BusinessService = lazy(()=>import('../pages/Business/Service'))
const BusinessServiceDetail = lazy(()=>import('../pages/Business/Service/Detail'))
const BusinessMoney = lazy(()=>import('../pages/Business/Money'))
const BusinessUpload = lazy(()=>import('../pages/Business/Upload'))
const BusinessUploadCopy = lazy(()=>import('../pages/Business/UploadCopy'))
const BusinessUploadEdit = lazy(()=>import('../pages/Business/UploadEdit'))
const BusinessAppeal = lazy(()=>import('../pages/Business/Appeal'))
const BusinessProof = lazy(()=>import('../pages/Business/Proof'))
const BusinessPending = lazy(()=>import('../pages/Business/Pending'))
const PendingDetail = lazy(()=>import('../pages/Business/Pending/Detail'))
const PendingAdd = lazy(()=>import('../pages/Business/Pending/Add'))
const BusinessHouseAdd = lazy(()=>import('../pages/Business/House/Add'))
const BusinessHouseAgent = lazy(()=>import('../pages/Business/House/Agent'))
const BusinessHouseYsb = lazy(()=>import('../pages/Business/House/Ysb'))
const BusinessHouseList = lazy(()=>import('../pages/Business/House/List'))
const BusinessHouseDetail = lazy(()=>import('../pages/Business/House/Detail'))
const BusinessHouseUpload = lazy(()=>import('../pages/Business/House/Upload'))
const BusinessHouseChannel = lazy(()=>import('../pages/Business/House/Channel'))
const BusinessHouseSign = lazy(()=>import('../pages/Business/House/SignList'))
const BusinessHousePhoto = lazy(()=>import('../pages/Business/House/Photo'))
const BusinessHouseSignCard = lazy(()=>import('../pages/Business/House/SignCard'))
const BusinessHouseSignDetail = lazy(()=>import('../pages/Business/House/SignDetail'))
const BusinessHouseChannelAdd = lazy(()=>import('../pages/Business/House/ChannelAdd'))
const BusinessHouseChannelDetail = lazy(()=>import('../pages/Business/House/ChannelDetail'))
const BusinessHouseRecommendAdd = lazy(()=>import('../pages/Business/House/Recommend/add.jsx'))
const BusinessHouseRecommendList = lazy(()=>import('../pages/Business/House/Recommend/list.jsx'))
const BusinessHouseBrokerage = lazy(()=>import('../pages/Business/House/Brokerage'))
const BusinessHouseBrokerageOrder = lazy(()=>import('../pages/Business/House/BrokerageOrder'))
const BusinessHouseBrokerageOrderList = lazy(()=>import('../pages/Business/House/BrokerageOrderList'))
const BusinessHouseBrokerageUser = lazy(()=>import('../pages/Business/House/BrokerageUser'))
const BusinessHouseSetBrokerage = lazy(()=>import('../pages/Business/House/SetBrokerage'))
const BusinessHouseBankManager = lazy(()=>import('../pages/Business/House/BankManager'))

const BusinessYsb = lazy(()=>import('../pages/Business/Ysb/index'))
const BusinessYsbList = lazy(()=>import('../pages/Business/Ysb/List'))
const BusinessYsbDetail = lazy(()=>import('../pages/Business/Ysb/detail'))
const BusinessStat = lazy(()=>import('../pages/Business/Stat'))
const BusinessSignin = lazy(()=>import('../pages/Business/Signin'))
const BusinessFinanceAudit = lazy(()=>import('../pages/Business/House/Finance/audit.jsx'))
const BusinessFinanceAuditNew = lazy(()=>import('../pages/Business/House/Finance/audit_new.jsx'))
const BusinessFinanceAuditDetail = lazy(()=>import('../pages/Business/House/Finance/audit_detail.jsx'))

const SignList = lazy(()=>import('../pages/Sign/List'))
const SignReject = lazy(()=>import('../pages/Sign/Reject'))
const SignUpdate = lazy(()=>import('../pages/Sign/Update'))
const SignHouse = lazy(()=>import('../pages/Sign/House'))

const ExamCenter = lazy(()=>import('../pages/Exam/Center'))
const ExamDetail = lazy(()=>import('../pages/Exam/Detail'))
const ExamList = lazy(()=>import('../pages/Exam/List'))
const ExamPaper = lazy(()=>import('../pages/Exam/Paper'))
const ExamLearn = lazy(()=>import('../pages/Exam/Learn'))
const ExamLearnDetail = lazy(()=>import('../pages/Exam/Learn/learnDetail.jsx'))

const TeamList = lazy(()=>import('../pages/Team/List'))
const TeamAppeal = lazy(()=>import('../pages/Team/Appeal'))
const TeamYsb = lazy(()=>import('../pages/Team/Ysb'))
const TeamHouse = lazy(()=>import('../pages/Team/House'))
const TeamHouseChannel = lazy(()=>import('../pages/Team/HouseChannel'))

const OutsideRegister = lazy(()=>import('../pages/Outside/Register'))
//const OutsideIndex = lazy(()=>import('../pages/Outside/Index'))
const OutsideAdd = lazy(()=>import('../pages/Outside/Add'))
const OutsideList = lazy(()=>import('../pages/Outside/List'))
const OutsideIndex = lazy(()=>import('../pages/Outside/Index/index.jsx'))
const OutsideDetail = lazy(()=>import('../pages/Outside/Detail'))
const OutsidePartner = lazy(()=>import('../pages/Outside/Partner'))
const OutsideTeam = lazy(()=>import('../pages/Outside/Team'))
const OutsideProduct = lazy(()=>import('../pages/Outside/Product'))
const OutsideAccount = lazy(()=>import('../pages/Outside/Account'))
const OutsideChannel = lazy(()=>import('../pages/Outside/Channel'))
const OutsideWork = lazy(()=>import('../pages/Outside/Work'))
const OutsideLogin = lazy(()=>import('../pages/Outside/Login'))

const ActivityCarRegister = lazy(()=>import('../pages/Activity/Car/Register'))
const ActivityCarSuccess = lazy(()=>import('../pages/Activity/Car/Success'))
const ActivityTest = lazy(()=>import('../pages/Activity/Test'))
const ActivityDemo = lazy(()=>import('../pages/Activity/Demo'))
const LotteryLogin = lazy(()=>import('../pages/Activity/Lottery/Login'))
const LotteryPrize = lazy(()=>import('../pages/Activity/Lottery/Prize'))
const LotterySuccess = lazy(()=>import('../pages/Activity/Lottery/Success'))
const CouponLogin = lazy(()=>import('../pages/Activity/Coupon/Login'))
const CouponSuccess = lazy(()=>import('../pages/Activity/Coupon/Success'))
const ICBCSigninLogin = lazy(()=>import('../pages/Activity/Signing/Login'))
const ICBCSigninRegister = lazy(()=>import('../pages/Activity/Signing/Register'))
const ICBCSigninSubscribe = lazy(()=>import('../pages/Activity/Signing/Subscribe'))
const ICBCSigninList = lazy(()=>import('../pages/Activity/Signing/List'))
const ICBCSigninSuccess = lazy(()=>import('../pages/Activity/Signing/Success'))
const ElifeQrcode = lazy(()=>import('../pages/Activity/Elife/Qrcode'))
const ElifeLogin = lazy(()=>import('../pages/Activity/Elife/Login'))

const InterfaceEsignAdd = lazy(()=>import('../pages/Interface/E-sign/Add'))
const InterfaceEsignOpen = lazy(()=>import('../pages/Interface/E-sign/Open'))
const InterfaceEsignEvidence = lazy(()=>import('../pages/Interface/E-sign/Evidence'))
const InterfaceEsignDetail = lazy(()=>import('../pages/Interface/E-sign/Detail'))
const InterfaceEsignList = lazy(()=>import('../pages/Interface/E-sign/List'))
const InterfaceEsignSuccess = lazy(()=>import('../pages/Interface/E-sign/Success'))

const FaqIndex = lazy(()=>import('../pages/FAQ/Index/index.jsx'))
const FaqLogin = lazy(()=>import('../pages/FAQ/Login'))
const FagList = (lazy(()=>import('../pages/FAQ/List')))
const FagDetail = (lazy(()=>import('../pages/FAQ/Detail')))
const FagCopilot = (lazy(()=>import('../pages/FAQ/Copilot')))

const HouseLoanLogin = lazy(()=>import('../pages/HouseLoan/Login'))
const HouseLoanHome = lazy(()=>import('../pages/HouseLoan/Home'))
const HouseLoanAdd = lazy(()=>import('../pages/HouseLoan/Add'))
const HouseLoanAuth = lazy(()=>import('../pages/HouseLoan/Auth'))
const HouseLoanPhoto = lazy(()=>import('../pages/HouseLoan/Photo'))
const HouseLoanWait = lazy(()=>import('../pages/HouseLoan/Wait'))
const HouseLoanMine = lazy(()=>import('../pages/HouseLoan/Mine'))
const HouseLoanList = lazy(()=>import('../pages/HouseLoan/List'))
const HouseLoanDetail = lazy(()=>import('../pages/HouseLoan/Detail'))
const HouseBestList = lazy(()=>import('../pages/HouseLoan/Best/list.jsx'))
const HouseBestdetail = lazy(()=>import('../pages/HouseLoan/Best/detail.jsx'))
const HouseServiceLogin = lazy(()=>import('../pages/HouseLoan/Service/Login.jsx'))
const HouseServiceDetail = lazy(()=>import('../pages/HouseLoan/Service/detail.jsx'))

const ChattergeeTool = (lazy(()=>import('../pages/Chattergee/Tool')))
const ChattergeeUser = (lazy(()=>import('../pages/Chattergee/User')))
const ChattergeeAuth = (lazy(()=>import('../pages/Chattergee/Auth')))
const ChattergeePurse = (lazy(()=>import('../pages/Chattergee/Purse')))
const ChattergeeSend = (lazy(()=>import('../pages/Chattergee/Send')))
const ChattergeeHome = (lazy(()=>import('../pages/Chattergee/Home')))
const ChattergeeList = (lazy(()=>import('../pages/Chattergee/Userlist/index.jsx')))
const ChattergeeAdd = (lazy(()=>import('../pages/Chattergee/Add')))

const LetusignHome = lazy(()=>import('../pages/Letusign/Home'))
const LetusignBuy = lazy(()=>import('../pages/Letusign/Buy'))
const LetusignShare = lazy(()=>import('../pages/Letusign/Share'))
const LetusignCustomer = lazy(()=>import('../pages/Letusign/Customer'))

const routes = [
  {
    path:'/',
    element:<Login/>
  },
  {
    path:'/login',
    element:<Login/>
  },
  {
    path:'/index',
    element:<Index/>
  },
  {
    path:'/business',
    element:<Business/>,
    children:[
      {
        path:'add',
        element:<BusinessAdd/>
      },
      {
        path:'list',
        element:<BusinessList/>
      },
      {
        path:'detail/:id',
        element:<BusinessDetail/>
      },
      {
        path:'reject',
        element:<BusinessReject/>
      },
      {
        path:'service',
        element:<BusinessService/>,
      },
      {
        path:'service_detail/:id',
        element:<BusinessServiceDetail/>,
      },
      {
        path:'money',
        element:<BusinessMoney/>
      },
      {
        path:'upload',
        element:<BusinessUpload/>
      },
      {
        path:'uploadCopy',
        element:<BusinessUploadCopy/>
      },
      {
        path:'edit',
        element:<BusinessUploadEdit/>
      },
      {
        path:'appeal',
        element:<BusinessAppeal/>
      },
      {
        path:'proof',
        element:<BusinessProof/>,
      },
      {
        path:'pending',
        element:<BusinessPending/>,
      },
      {
        path:'pendingDetail/:id',
        element:<PendingDetail/>,
      },
      {
        path:'pendingAdd/:id',
        element:<PendingAdd/>,
      },
      {
        path:'house',
        element:<BusinessHouseList/>,
      },
      {
        path:'houseYsb/:id',
        element:<BusinessHouseYsb/>,
      },
      {
        path:'houseAdd',
        element:<BusinessHouseAdd/>,
      },
      {
        path:'houseAgent',
        element:<BusinessHouseAgent/>,
      },
      {
        path:'houseDetail/:father/:id',
        element:<BusinessHouseDetail/>,
      },
      {
        path:'houseUpload/:id/:house_type',
        element:<BusinessHouseUpload/>,
      },
      {
        path:'houseSign',
        element:<BusinessHouseSign/>,
      },
      {
        path:'housePhoto',
        element:<BusinessHousePhoto/>,
      },
      {
        path:'houseSignCard',
        element:<BusinessHouseSignCard/>,
      },
      {
        path:'houseSignDetail/:id',
        element:<BusinessHouseSignDetail/>,
      },
      {
        path:'houseChannel',
        element:<BusinessHouseChannel/>,
      },
      {
        path:'houseChannelAdd',
        element:<BusinessHouseChannelAdd/>,
      },
      {
        path:'houseChannelDetail/:id',
        element:<BusinessHouseChannelDetail/>,
      },
      {
        path:'houseRecommendAdd',
        element:<BusinessHouseRecommendAdd/>,
      },
      {
        path:'houseRecommendList',
        element:<BusinessHouseRecommendList/>,
      },
      {
        path:'houseBrokerage',
        element:<BusinessHouseBrokerage/>,
      },
      {
        path:'houseBrokerageOrder',
        element:<BusinessHouseBrokerageOrder/>,
      },
      {
        path:'houseBrokerageOrderList/:param',
        element:<BusinessHouseBrokerageOrderList/>,
      },
      {
        path:'houseBrokerageUser',
        element:<BusinessHouseBrokerageUser/>,
      },
      {
        path:'houseSetBrokerage/:father/:id',
        element:<BusinessHouseSetBrokerage/>,
      },
      {
        path:'houseBankManager',
        element:<BusinessHouseBankManager/>,
      },
      {
        path:'ysb',
        element:<BusinessYsb/>,
      },
      {
        path:'ysblist',
        element:<BusinessYsbList/>,
      },
      {
        path:'ysbdetail/:userid',
        element:<BusinessYsbDetail/>,
      },
      {
        path:'stat',
        element:<BusinessStat/>
      },
      {
        path:'signin',
        element:<BusinessSignin/>
      },
      {
        path:'financeAudit',
        element:<BusinessFinanceAudit/>
      },
      {
        path:'financeAuditNew',
        element:<BusinessFinanceAuditNew/>
      },
      {
        path:'financeAuditDetail/:id',
        element:<BusinessFinanceAuditDetail/>
      },
    ]
  },
  {
    path:'/team',
    element:<Team/>,
    children:[
      {
        path:'list',
        element:<TeamList/>
      },
      {
        path:'appeal',
        element:<TeamAppeal/>
      },
      {
        path:'ysb',
        element:<TeamYsb/>
      },
      {
        path:'house',
        element:<TeamHouse/>
      },
      {
        path:'houseChannel',
        element:<TeamHouseChannel/>
      }
    ]
  },
  {
    path:'/exam',
    element:<Exam/>,
    children:[
      {
        path:'center',
        element:<ExamCenter/>
      },
      {
        path:'detail/:id',
        element:<ExamDetail/>
      },
      {
        path:'list',
        element:<ExamList/>
      },
      {
        path:'paper/:id',
        element:<ExamPaper/>
      },
      {
        path:'learn',
        element:<ExamLearn/>
      },
      {
        path:'learnDetail',
        element:<ExamLearnDetail/>
      },
    ]
  },
  {
    path:'/sign',
    element:<Sign/>,
    children:[
      {
        path:'list/:userid/:flag',
        element:<SignList/>
      },
      {
        path:'reject',
        element:<SignReject/>
      },
      {
        path:'update/:id',
        element:<SignUpdate/>
      },
      {
        path:'house',
        element:<SignHouse/>
      }
    ]
  },
  {
    path:'/outside',
    element:<Outside/>,
    children:[
      {
        path:'',
        element:<Navigate to="index"/>
      },
      {
        path:'index/:openid',
        element:<OutsideIndex/>
      },
      {
        path:'register',
        element:<OutsideRegister/>
      },
      {
        path:'add',
        element:<OutsideAdd/>
      },
      {
        path:'list',
        element:<OutsideList/>
      },
      {
        path:'detail/:id',
        element:<OutsideDetail/>
      },
      {
        path:'partner',
        element:<OutsidePartner/>
      },
      {
        path:'team',
        element:<OutsideTeam/>
      },
      {
        path:'product',
        element:<OutsideProduct/>
      },
      {
        path:'account',
        element:<OutsideAccount/>
      },
      {
        path:'channel',
        element:<OutsideChannel/>
      },
      {
        path:'work',
        element:<OutsideWork/>
      },
      {
        path:'login',
        element:<OutsideLogin/>
      }
    ]
  },
  {
    path:'/faq',
    element:<FAQ/>,
    children:[
      {
        path:'',
        element:<Navigate to="login"/>
      },
      {
        path:'login',
        element:<FaqLogin/>
      },
      {
        path:'index',
        element:<FaqIndex/>
      },
      {
        path:'list',
        element:<FagList/>
      },
      {
        path:'detail/:id',
        element:<FagDetail/>
      },
      {
        path:'copilot',
        element:<FagCopilot/>
      }
    ]
  },
  {
    path:'houseloan',
    element:<HouseLoan/>,
    children:[
      {
        path:'login',
        element:<HouseLoanLogin/>
      },
      {
        path:'home/:openid',
        element:<HouseLoanHome/>
      },
      {
        path:'add/:type',
        element:<HouseLoanAdd/>
      },
      {
        path:'auth/:id/:type',
        element:<HouseLoanAuth/>
      },
      {
        path:'photo',
        element:<HouseLoanPhoto/>
      },
      {
        path:'wait',
        element:<HouseLoanWait/>
      },
      {
        path:'mine',
        element:<HouseLoanMine/>
      },
      {
        path:'list',
        element:<HouseLoanList/>
      },
      {
        path:'detail/:id',
        element:<HouseLoanDetail/>
      },
      {
        path:'bestList',
        element:<HouseBestList/>
      },
      {
        path:'bestDetail/:id',
        element:<HouseBestdetail/>
      },
      {
        path:'service',
        children:[
          {
            path:'login/:openid',
            element:<HouseServiceLogin/>
          },
          {
            path:'detail/:openid',
            element:<HouseServiceDetail/>
          }
        ]
      }

    ]
  },
  {
    path:'chattergee',
    element:<Chattergee/>,
    children:[
      {
        path:'',
        element:<Navigate to="home"/>
      },
      {
        path:'home',
        element:<ChattergeeHome/>
      },
      {
        path:'list/:id',
        element:<ChattergeeList/>
      },
      {
        path:'add/:id',
        element:<ChattergeeAdd/>
      },
      {
        path:'tool',
        element:<ChattergeeTool/>
      },
      {
        path:'user',
        element:<ChattergeeUser/>
      },
      {
        path:'auth/:id',
        element:<ChattergeeAuth/>
      },
      {
        path:'purse/:id',
        element:<ChattergeePurse/>
      },
      {
        path:'send/:external_userid',
        element:<ChattergeeSend/>
      },
    ]
    
  },
  {
    path:'/activity',
    element:<Activity/>,
    children:[
      {
        path:'',
        element:<Navigate to="test"/>
      },
      {
        path:'test',
        element:<ActivityTest/>
      },
      {
        path:'demo',
        element:<ActivityDemo/>
      },
      {
        path:'car',
        children:[
          {
            path:'',
            element:<ActivityCarSuccess/>
          },
          {
            path:'register/:activity_id',
            element:<ActivityCarRegister/>
          },
          {
            path:'success',
            element:<ActivityCarSuccess/>
          }
        ]
      },
      {
        path:'lottery',
        children:[
          {
            path:'',
            element:<LotteryLogin/>
          },
          {
            path:'login',
            element:<LotteryLogin/>
          },
          {
            path:'Prize',
            element:<LotteryPrize/>
          },
          {
            path:'success',
            element:<LotterySuccess/>
          },
        ]
      },
      {
        path:'coupon',
        children:[
          {
            path:'',
            element:<CouponLogin/>
          },
          {
            path:'login/:openid',
            element:<CouponLogin/>
          },
          {
            path:'success',
            element:<CouponSuccess/>
          },
        ]
      },
      /* {
        path:'lotteryLogin',
        element:<LotteryLogin/>
      },
      {
        path:'lotteryPrize',
        element:<LotteryPrize/>
      },
      {
        path:'lotterySuccess',
        element:<LotterySuccess/>
      }, */
      {
        path:'signin',
        children:[
          {
            path:'',
            element:<ICBCSigninRegister/>
          },
          {
            path:'register',
            element:<ICBCSigninRegister/>
          },
          {
            path:'subscribe',
            element:<ICBCSigninSubscribe/>
          },
          {
            path:'login',
            element:<ICBCSigninLogin/>
          },
          {
            path:'list',
            element:<ICBCSigninList/>
          },
          {
            path:'success',
            element:<ICBCSigninSuccess/>
          },
        ]
      },
      {
        path:'elife',
        children:[
          {
            path:'qrcode',
            element:<ElifeQrcode/>
          },
          {
            path:'login/:ticket',
            element:<ElifeLogin/>
          },
        ]
      }
    ]
  },
  {
    path:'/interface',
    element:<Interface/>,
    children:[
      {
        path:'',
        element:<Navigate to="esign"/>
      },
      {
        path:'esign',
        element:<InterfaceEsignList/>
      },
      {
        path:'esign',
        children:[
          {
            path:'list',
            element:<InterfaceEsignList/>
          },
          {
            path:'add/:user_id',
            element:<InterfaceEsignAdd/>
          },
          {
            path:'open/:id',
            element:<InterfaceEsignOpen/>
          },
          {
            path:'evidence/:id',
            element:<InterfaceEsignEvidence/>
          },
          {
            path:'detail/:id',
            element:<InterfaceEsignDetail/>
          },
          {
            path:'success',
            element:<InterfaceEsignSuccess/>
          }
        ]
      },
      {
        path:'lottery',
        children:[
          {
            path:'',
            element:<LotteryLogin/>
          },
          {
            path:'login',
            element:<LotteryLogin/>
          },
          {
            path:'Prize',
            element:<LotteryPrize/>
          },
          {
            path:'success',
            element:<LotterySuccess/>
          },
        ]
      },
      {
        path:'coupon',
        children:[
          {
            path:'',
            element:<CouponLogin/>
          },
          {
            path:'login/:openid',
            element:<CouponLogin/>
          },
          {
            path:'success',
            element:<CouponSuccess/>
          },
        ]
      },
      {
        path:'signin',
        children:[
          {
            path:'',
            element:<ICBCSigninRegister/>
          },
          {
            path:'register',
            element:<ICBCSigninRegister/>
          },
          {
            path:'subscribe',
            element:<ICBCSigninSubscribe/>
          },
          {
            path:'login',
            element:<ICBCSigninLogin/>
          },
          {
            path:'list',
            element:<ICBCSigninList/>
          },
          {
            path:'success',
            element:<ICBCSigninSuccess/>
          },
        ]
      }
    ]
  },
  {
    path:'/calculator',
    element:<Calculator/>
  },
  {
    path:'/letusign',
    element:<Letusign/>,
    children:[
      {
        path:'',
        element:<Navigate to="home"/>
      },
      {
        path:'home',
        element:<LetusignHome/>
      },
      {
        path:'buy/:uuid',
        element:<LetusignBuy/>
      },
      {
        path:'share/:uuid',
        element:<LetusignShare/>
      },
      {
        path:'customer/:uuid',
        element:<LetusignCustomer/>
      }
    ]
  }
] 

export default routes